import { render, staticRenderFns } from "./deadline-edit.vue?vue&type=template&id=2cea6538"
import script from "./deadline-edit.vue?vue&type=script&lang=js"
export * from "./deadline-edit.vue?vue&type=script&lang=js"
import style0 from "./deadline-edit.vue?vue&type=style&index=0&id=2cea6538&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports